const Tabs = () => {

    // Find the wrapping div around this set of tabs
    const tabs = document.querySelector('[data-tabs]');
    // Find the navigation links for these tabs
    const tab_links = tabs.querySelectorAll('[data-tab-link]');
    // Fetch each tab available within this set of tabs
    const tab_content = tabs.querySelectorAll('[data-tab]');

    // Using the index of the tab, conditionally show and hide the tabs
    function displayCurrentTab(current) {
        // Loop through each tab by index to show or hide
        for (let i = 0; i < tab_content.length; i++) {
            // If the index matches that passed into the function, add display: block
            // to this tab, otherwise hide this
            tab_content[i].style.display = (current === i) ? 'block' : 'none';
        }
    }

    // Initialise the tabs by selecting the first tab as active
    displayCurrentTab(0);

    // Loop through each tab link to add/remove active states
    tab_links.forEach(tab_link => {

        tab_link.addEventListener('click', event => {
            // Stop the default behaviour of the link
            event.preventDefault();

            // Store the clicked tab link attribute for which tab to show
            let select_tab = event.target.getAttribute('data-tab-link');
            
            // Toggle the tabs
            toggleTabs(select_tab);
        });
    });

    function toggleTabs(select_tab) {

        // If this has a value, proceed
        if (select_tab) {

            // Loop through each tab link to add/remove active states
            tab_links.forEach(tab_link => {  

                // If the data attribute matches the tab we just clicked, add the
                // is-active class to the tab
                if (tab_link.getAttribute('data-tab-link') == select_tab) {
                    tab_link.classList.add('is-active');
                } else {
                    // Otherwise remove the active state from the tab
                    tab_link.classList.remove('is-active');
                }
            });

            // Now loop through each tab content elements
            for (let i = 0; i < tab_content.length; i++) {

                // Get the tab content data attribute value
                let tab_title = tab_content[i].getAttribute('data-tab');

                // If it has a value, proceed
                if (typeof tab_title != "undefined" && tab_title != null) {

                    // If the attribute of the tab content matches that of the tap link,
                    // this is the tab we need to show
                    if (select_tab === tab_content[i].getAttribute('data-tab')) {
                        
                        // Display the current tab to the end user
                        displayCurrentTab(i);
                        break;
                    }
                }
            }
        }
    }
}

export default Tabs;